import {
  ADMIN_SIGNALS_PATH,
  ADMIN_TRADING_CONFIGURATION_FORM_PATH,
  ADMIN_TRADING_CONFIGURATION_PATH,
  AFFILIATION_PATH,
  BASE_BOT_FORM_PATH,
  BASE_BOTS_BACKTESTING_PATH,
  BASE_BOTS_PATH,
  BASE_MY_BOTS_PATH,
  BASE_PUBLIC_BOT_PATH,
  BASE_PUBLIC_EDIT_BOT_PATH,
  BOTS_PATH,
  CREATE_ACCOUNT_PATH,
  CREATE_SIGNAL_PATH,
  CREATE_TRADE_PATH,
  DASHBOARD_PATH,
  DCA_PUBLIC_BOTS_PATH,
  FINANCE_PATH,
  USER_SIGNALS_PATH,
  GROUP_MANAGEMENT_PATH,
  MARKETPLACE_PATH,
  MCP_PATH,
  MY_GROUPS_PATH,
  ONBOARDING_PATHS,
  PORTFOLIO_ACCOUNTS_PATH,
  PORTFOLIO_ASSETS_PATH,
  PORTFOLIO_PATH,
  PORTFOLIO_POSITIONS_PATH,
  SETTINGS_PATH,
  TRADES_PATH,
  BASE_BOTS_SIGNALS_PATH,
  WATCHLIST_PATH,
  CONNECT_WHOP_CHANNEL_PATH,
  WHOP_CHANNEL_ERROR_PATH,
  INVOICES_PATH,
  BUSINESS_PROFILE_PATH,
  USERS_MANAGEMENT_PATH,
} from "common/constants.ts";
import { AppScreen, PageData } from "common/Home/General/types.ts";
import OnboardingProvider from "features/onboarding/OnboardingProvider.tsx";
import GroupManagement from "features/admin/group/GroupManagement.tsx";
import Watchlist from "features/watchlist/Watchlist.tsx";
import BotForm from "features/bots/BotForm/BotForm.tsx";
import TradingConfiguration from "features/admin/TradingConfiguration/TradingConfiguration.tsx";
import PublicBotPreview from "features/bots/PublicBots/PublicBotPreview.tsx";
import MyGroupsPage from "features/bots/Groups/MyGroupsPage.tsx";
import TradingTerminalWrapper from "features/tradingTerminal/TradingTerminalWrapper.tsx";
import Dashboard from "features/dashboard/Dashboard.tsx";
import Marketplace from "features/newMarketplace/Marketplace.tsx";
import TradesPage from "features/trades/TradesPage.tsx";
import PortfolioPage from "features/portfolio/PortfolioPage.tsx";
import BotsPage from "features/bots/BotsPage.tsx";
import BacktestingPage from "features/bots/BotForm/Backtesting/BacktestingPage/BacktestingPage.tsx";
import PublicBots from "features/bots/PublicBots/PublicBots.tsx";
import Bots from "features/bots/Bots.tsx";
import Settings from "features/settings/Settings.tsx";
import SignalsPage from "features/signals/SignalsPage.tsx";
import Affiliation from "features/affiliation/Affiliation.tsx";
import { SIGNAL_BOTS_SIGNALS_PATH } from "features/bots/common/constants.ts";
import ConnectWhopChannel from "features/whop/ConnectWhopChannel.tsx";
import NoConnectChannelError from "features/whop/NoConnectChannelError.tsx";
import Invoices from "features/payouts/Invoices/Invoices.tsx";
import BusinessProfile from "features/assetManager/BusinessProfile/BusinessProfile.tsx";
import UsersManagement from "features/users-management/UsersManagement.tsx";
import McpPage from "features/mcp/McpPage.tsx";
import FinancePage from "features/finance/FinancePage.tsx";

export const PAGES_DATA: { [key in AppScreen]?: PageData } = {
  [AppScreen.ONBOARDING]: {
    path: ONBOARDING_PATHS,
    component: OnboardingProvider,
  },
  [AppScreen.GROUP_MANAGEMENT]: {
    path: GROUP_MANAGEMENT_PATH,
    component: GroupManagement,
  },
  [AppScreen.WATCHLIST]: {
    path: WATCHLIST_PATH,
    component: Watchlist,
  },
  [AppScreen.BOT_FORM]: {
    path: [
      BASE_PUBLIC_EDIT_BOT_PATH,
      BASE_BOT_FORM_PATH,
      ADMIN_TRADING_CONFIGURATION_FORM_PATH,
    ],
    component: BotForm,
  },
  [AppScreen.ADMIN_TRADING_CONFIGURATION]: {
    path: ADMIN_TRADING_CONFIGURATION_PATH,
    component: TradingConfiguration,
  },
  [AppScreen.PUBLIC_BOT_PREVIEW]: {
    path: BASE_PUBLIC_BOT_PATH,
    component: PublicBotPreview,
  },
  [AppScreen.MY_GROUPS]: {
    path: MY_GROUPS_PATH,
    component: MyGroupsPage,
  },
  [AppScreen.TRADING_TERMINAL]: {
    path: CREATE_TRADE_PATH,
    component: TradingTerminalWrapper,
  },
  [AppScreen.SIGNAL_TERMINAL]: {
    path: CREATE_SIGNAL_PATH,
    component: TradingTerminalWrapper,
  },
  [AppScreen.DASHBOARD]: {
    path: DASHBOARD_PATH,
    component: Dashboard,
    isBottomNavigatorScreen: true,
  },
  [AppScreen.MARKETPLACE]: {
    path: MARKETPLACE_PATH,
    component: Marketplace,
    isBottomNavigatorScreen: true,
  },
  [AppScreen.TRADES]: {
    path: TRADES_PATH,
    component: TradesPage,
    isBottomNavigatorScreen: true,
  },
  [AppScreen.PORTFOLIO]: {
    path: [
      PORTFOLIO_PATH,
      PORTFOLIO_ACCOUNTS_PATH,
      PORTFOLIO_ASSETS_PATH,
      PORTFOLIO_POSITIONS_PATH,
      CREATE_ACCOUNT_PATH,
    ],
    component: PortfolioPage,
    isMobileOnly: true,
    isBottomNavigatorScreen: true,
  },
  [AppScreen.ASSETS]: {
    path: [PORTFOLIO_ASSETS_PATH, PORTFOLIO_POSITIONS_PATH],
    component: PortfolioPage,
    isDesktopOnly: true,
  },
  [AppScreen.ACCOUNTS]: {
    path: [PORTFOLIO_ACCOUNTS_PATH, PORTFOLIO_PATH],
    component: PortfolioPage,
    isDesktopOnly: true,
  },
  [AppScreen.BOTS]: {
    path: [
      BOTS_PATH,
      BASE_BOTS_BACKTESTING_PATH,
      DCA_PUBLIC_BOTS_PATH,
      BASE_BOTS_PATH,
      BASE_MY_BOTS_PATH,
      BASE_BOTS_SIGNALS_PATH,
    ],
    excludePaths: [
      BASE_BOT_FORM_PATH,
      BASE_PUBLIC_BOT_PATH,
      BASE_PUBLIC_EDIT_BOT_PATH,
    ],
    component: BotsPage,
    isMobileOnly: true,
    isBottomNavigatorScreen: true,
  },
  [AppScreen.BACKTESTING]: {
    path: BASE_BOTS_BACKTESTING_PATH,
    component: BacktestingPage,
    isDesktopOnly: true,
  },
  [AppScreen.PUBLIC_BOTS]: {
    path: DCA_PUBLIC_BOTS_PATH,
    component: PublicBots,
    isDesktopOnly: true,
  },
  [AppScreen.USER_SIGNALS]: {
    path: SIGNAL_BOTS_SIGNALS_PATH,
    component: SignalsPage,
    isDesktopOnly: true,
  },
  [AppScreen.MY_BOTS]: {
    path: BASE_BOTS_PATH,
    component: Bots,
    isDesktopOnly: true,
  },
  [AppScreen.SETTINGS]: {
    path: SETTINGS_PATH,
    component: Settings,
  },
  [AppScreen.SIGNALS]: {
    path: [ADMIN_SIGNALS_PATH, USER_SIGNALS_PATH],
    component: SignalsPage,
  },
  [AppScreen.AFFILIATION]: {
    path: AFFILIATION_PATH,
    component: Affiliation,
  },
  [AppScreen.CONNECT_WHOP_CHANNEL]: {
    path: CONNECT_WHOP_CHANNEL_PATH,
    component: ConnectWhopChannel,
  },
  [AppScreen.WHOP_CHANNEL_ERROR]: {
    path: WHOP_CHANNEL_ERROR_PATH,
    component: NoConnectChannelError,
  },
  [AppScreen.INVOICES]: {
    path: INVOICES_PATH,
    component: Invoices,
  },
  [AppScreen.BUSINESS_PROFILE]: {
    path: BUSINESS_PROFILE_PATH,
    component: BusinessProfile,
  },
  [AppScreen.USERS_MANAGEMENT]: {
    path: USERS_MANAGEMENT_PATH,
    component: UsersManagement,
  },
  [AppScreen.MCP]: {
    path: MCP_PATH,
    component: McpPage,
  },
  [AppScreen.FINANCE]: {
    path: FINANCE_PATH,
    component: FinancePage,
  },
};
